export function lerp(start, end, value) {
  return (1 - value) * start + value * end
}

export function inverseLerp(start, end, value) {
  return (value - start) / (end - start)
}
